import axios from "axios";
import { useState, useEffect } from "react";
import { GiConsoleController } from "react-icons/gi";
import { authenticationResponse } from "../components/Auth/auth.models";
import { getClaims } from "../components/Auth/handleJWT";
import { urlManageCompanies, urlSettings } from "../endpoints";
import { SettingsModel } from "../views/Admin/Settings/Settings";
import { CompanyModel } from "../views/Company/company.model";
import { getCompanyInfo } from "../views/Company/manageCompany";

export const useSettings = () => {
  const [settings, setSettings] = useState<SettingsModel>({});

  async function getSettingsInfo() {
    try {
      const response = await axios.get<SettingsModel>(`${urlSettings}`);
      if (response.status == 200) {
        return response.data;
      }
    } catch (error: any) {
      // console.log(error);
    }
  }

  useEffect(() => {
    const getSettingsAsync = async () => {
      let results = await getSettingsInfo();
      if (results) {
        setSettings(results);
        //console.log(results);
      }
    };
    getSettingsAsync();
  }, []);

  return { settings, setSettings };
};
